<template>
	<NavSidebarGroup
		v-if="shouldShowInboxNavItem"
		key="teamless-inbox"
		class="nav-sidebar__group"
		:is-selected="isSelected"
		@click="$emit( 'nav', 'navigateToInbox' )"
	>
		<template #icon>
			<FontAwesomeIcon :icon="[ 'fas', 'inbox-full', ]" />
		</template>
		<template #text>
			{{ text }}
		</template>
		<template #tooltip>
			{{ tooltip }}
		</template>
		<template #badge>
			{{ teamlessMeetingsBadgeCount }}
		</template>
	</NavSidebarGroup>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import NavSidebarGroup from "../layouts/NavSidebar/NavSidebarGroup";

export default {
	name: "TeamlessInboxNavItem",
	components: {
		NavSidebarGroup,
	},
	props: {},
	data() {
		return {
			text: this.$t( "teaming-web.layouts.NavSidebarHOC.inboxTitle" ),
			tooltip: this.$t( "teaming-web.layouts.NavSidebarHOC.inboxTitle" ),
		};
	},
	computed: {
		...mapState( "inbox", [
			"featureFlag",
		] ),
		...mapGetters( "inbox", [
			"teamlessMeetingsBadgeCount",
		] ),
		isSelected() {
			return this.$route.name === "Inbox";
		},
		shouldShowInboxNavItem() {
			return this.featureFlag && this.teamlessMeetingsBadgeCount > 0;
		},
	},
	methods: {
		...mapActions( "inbox", [
			"tryFetchTeamlessMeetings",
		] ),
	},
	mounted() {
		if ( this.$route.name !== "Inbox" ) {
			this.tryFetchTeamlessMeetings();
		}
	},
};
</script>
